import React, { useState } from "react";
import Nav from "react-bootstrap/Nav";
import styled from "styled-components";

//*interfaces
interface PropsMenuV {
  menu: any;
}

export default function ParteMenu(props: PropsMenuV) {
  let menu = props.menu;

  const [isOpened, setIsOpened] = useState(false);
  const [step, setStep] = useState("1");

  function toggle(stepId: any, activo: any, subm: any) {
    if (subm !== null) {
      if (step !== stepId) {
        let stepAnt = Number(step) - 1;

        if (stepAnt >= 0) menu[stepAnt].activo = "f";

        if (menu[stepId - 1].activo === "t") {
          menu[stepId - 1].activo = "f";
          setIsOpened(false);
        } else {
          menu[stepId - 1].activo = "t";
          setIsOpened(true);
        }
        setStep(stepId);
      } else {
        if (menu[stepId - 1].activo === "t") {
          menu[stepId - 1].activo = "f";
          setIsOpened(false);
        } else {
          menu[stepId - 1].activo = "t";
          setIsOpened(true);
        }
        setStep("0");
      }
    }
  }

  return (
    <div>
      <Nav variant="pills" className="flex-column navM  " id="menu">
        {menu.map((item: any) => (
          <Nav.Item key={item.id} id={"idnav" + item.id}>
            <Navnav id="navnav">
              <Nav.Link
                eventKey={item.id}
                disabled={item.isDisabled}
                onClick={() => toggle(item.id, item.activo, item.subMenu)}
              >
                {item.desc}

                {item.subMenu !== null ? (
                  <div>
                    <nav>
                      <ul>
                        {" "}
                        <li>
                          <div>
                            {item.subMenu.map((itemS: any) => (
                              <>
                                <li>
                                  {item.activo !== "f" ? (
                                    <>
                                      {isOpened && (
                                        <>
                                          <a href="#">{itemS.desc}</a>
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </li>
                              </>
                            ))}
                          </div>
                        </li>
                      </ul>
                    </nav>
                  </div>
                ) : (
                  <span></span>
                )}
                <div className="background-Navy "></div>
              </Nav.Link>
            </Navnav>
          </Nav.Item>
        ))}
      </Nav>
    </div>
  );
}

const Navnav = styled.div`
width: "258px",
textDecoration: "underline",
`;
